import { PayloadAction } from "@reduxjs/toolkit";
import { ApplicationState, MenuItems } from "../../types";

type Payload = MenuItems;

export const setActiveMenuItem = (
  state: ApplicationState,
  { payload }: PayloadAction<Payload>
) => {
  state.activeMenuItem = payload;
};
